module.exports = __webpack_public_path__ + "img/PPMP15.5f91d233.png";